import React, { Component } from "react";
import { WebContainer } from "app/NativeComponents/common";

class CopyContainer extends Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.copy_tab != "" &&
      prevProps.copy_tab != this.props.copy_tab
    ) {
      var elem = document.getElementById("myScroll");
      elem.scrollTop = this.props.window_height - 190;
    }
  }

  render() {
    if (!this.props.isMobile) {
      return (
        <div id="myScroll" className="deal-start-left">
          <div className="deal-video-container">
            <div className="deal-video-wrapper">
              <video className="deal-background-video" loop autoPlay>
                <source src="/assets/videos/video.mp4" type="video/mp4" />
                <source
                  src="/assets/videos/video.oggtheora.ogv"
                  type="video/ogv"
                />
                <source
                  src="/assets/videos/video.webmhd.webm"
                  type="video/webm"
                />
              </video>
            </div>

            <div className="deal-video-inner">{this.props.titleScreen()}</div>
          </div>
          <WebContainer>{this.props.children}</WebContainer>
        </div>
      );
    }

    return (
      <div id="myScroll" className="deal-start-left">
        <WebContainer>{this.props.children}</WebContainer>
      </div>
    );
  }
}

export default CopyContainer;
